import AvatarFormErrorModel from "./form-error.model";

class AvatarFormModel {
  constructor() {
    this.avatar = '';
    this.file = '';

    this.error = new AvatarFormErrorModel();
  }

  setFormErrors(errors) {
    this.error.setFormErrors(errors);
  }

  toPayload() {
    const formData = new FormData();

    formData.append('memberAvatar[avatar]', this.avatar);
    formData.append('memberAvatar[file]', this.file);

    return formData;
  }

  reset() {
    this.avatar = '';
    this.file = '';
    
    this.setFormErrors('');
  }
}

export default AvatarFormModel;


// WEBPACK FOOTER //
// ./client/app/pages/settings/component/avatar/model/form.model.js